import { Box, Spinner, Text } from '@chakra-ui/react';
import { type FC } from 'react';
import styles from '../styles/map.module.scss';
import { translateAndFormat } from '../constants/translation';

interface Props {
  operation: string;
}

const BlurMap: FC<Props> = ({ operation }) => {
  return (
    <div className={styles.mapBlur}>
      <Box height="100%" width="100%" position="absolute">
        <div className={styles.centerText}>
          <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
          <Text>{translateAndFormat('LOADING_DATA_FOR_OPERATION', operation)}</Text>
        </div>
      </Box>
    </div>
  );
};

export default BlurMap;
